module.exports = require("./fr-TG");